import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=2817bc53&"
import script from "./DeviceInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=2817bc53&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports